<mat-form-field
  class="density-minus-3"
  (click)="ensurePanelOpen()"
  subscriptSizing="dynamic"
  appearance="outline"
>
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-chip-grid #chipList>
    <mat-chip-row
      *ngFor="let value of selectedValues$ | async; index as i"
      removable
      (removed)="removeIndex(i)"
      [disabled]="disabled"
    >
      {{ value }}
      <fa-icon
        [icon]="faTimesCircle"
        [fixedWidth]="true"
        matChipRemove
      ></fa-icon>
    </mat-chip-row>
    <input
      [disabled]="disabled"
      #chipsInput
      [formControl]="formControl"
      [matAutocomplete]="autocomplete"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
      (matChipInputTokenEnd)="onChipInputTokenEnd($event.value)"
    />
    <mat-autocomplete
      #autocomplete="matAutocomplete"
      (optionSelected)="onOptionSelected($event.option.value)"
    >
      <mat-option
        *ngFor="let value of valuesForAutocomplete$ | async"
        [value]="value"
      >
        {{ value }}
      </mat-option>
    </mat-autocomplete>
  </mat-chip-grid>
  <ng-template #helpMessage>
    <h3-help-tooltip text="Press enter to add a tag"></h3-help-tooltip>
  </ng-template>
  <h3-help-tooltip
    *ngIf="showWarning$ | async; else helpMessage"
    [text]="warning$ | async"
    type="exclamation"
  ></h3-help-tooltip>
</mat-form-field>
